<!-- SwipFx Orders Page (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">
    <app-header [page]="'Admin'"></app-header>
    <main class="container py-4">
  <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
    <div>
      <h3 class="fw-bold mb-1">Compliance Review Details</h3>
      <p class="text-muted mb-0">Inspect submitted values and approve or reject documents.</p>
    </div>
    <a class="btn btn-outline-secondary btn-sm" routerLink="/admin/compliance/reviews">Back to Queue</a>
  </div>

  <div *ngIf="loading" class="text-center text-muted py-4">Loading review details...</div>

  <div *ngIf="backendHint" class="alert alert-warning">
    This frontend expects <code>GET /Compliance/admin/kyc/reviews/{{ applicationId }}</code>.
    Add that endpoint and return <code>AdminKycApplicationDetailsDto</code> from <code>KycAdminReviewService.GetApplicationByIdAsync</code>.
  </div>

  <ng-container *ngIf="!loading && item as app">
    <div class="card border-0 shadow-sm mb-4">
      <div class="card-body">
        <div class="row g-3 small">
          <div class="col-md-3"><div class="text-muted">Applicant</div><div class="fw-semibold">{{ app.fullName }}</div><div class="text-muted">{{ app.email }}</div></div>
          <div class="col-md-3"><div class="text-muted">Status</div><div class="fw-semibold">{{ app.status }}</div></div>
          <div class="col-md-3"><div class="text-muted">Tier</div><div class="fw-semibold">{{ app.tierCode }}</div></div>
          <div class="col-md-3"><div class="text-muted">Jurisdiction</div><div class="fw-semibold">{{ app.jurisdictionCode }}</div></div>
        </div>
        <div class="d-flex gap-2 flex-wrap mt-3">
          <button class="btn btn-outline-primary btn-sm" *ngIf="app.status === 'Submitted'" (click)="startReview()">Start Review</button>
          <button class="btn btn-outline-success btn-sm" *ngIf="app.status === 'UnderReview'" (click)="approveApplication()">Approve Application</button>
          <button class="btn btn-outline-danger btn-sm" *ngIf="app.status === 'UnderReview' || app.status === 'Submitted'" (click)="rejectApplication()">Reject Application</button>
        </div>
        <div class="alert alert-warning mt-3 mb-0" *ngIf="app.reviewNotes"><strong>Review notes:</strong> {{ app.reviewNotes }}</div>
      </div>
    </div>

    <div class="row g-3">
      <div class="col-lg-6">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body">
            <h5 class="mb-3">Submitted Fields</h5>
            <div class="border-bottom py-2" *ngFor="let field of app.fields">
              <div class="small text-muted">{{ field.label }}</div>
              <div class="fw-semibold">{{ field.fieldValue || '-' }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body">
            <h5 class="mb-3">Documents</h5>
            <div class="border rounded-3 p-3 mb-2" *ngFor="let doc of app.documents">
              <div class="d-flex justify-content-between gap-2 align-items-start">
                <div>
                  <div class="fw-semibold">{{ doc.label }}</div>
                  <div class="small text-muted">{{ doc.fileName }}</div>
                  <div class="small text-muted">{{ doc.storageUrl }}</div>
                </div>
                <span class="badge text-bg-light border">{{ doc.status }}</span>
              </div>
              <div class="d-flex gap-2 mt-3" *ngIf="app.status === 'UnderReview' || app.status === 'Submitted'">
                <button class="btn btn-outline-success btn-sm" (click)="approveDocument(doc.id)">Approve Document</button>
                <button class="btn btn-outline-danger btn-sm" (click)="rejectDocument(doc.id)">Reject Document</button>
              </div>
              <div class="small text-danger mt-2" *ngIf="doc.rejectionReason">{{ doc.rejectionReason }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

        <app-footer></app-footer>
    </main>
</div>
